import { camel } from 'radashi'
import { z } from 'zod'

import type { FeatureFlagsChangedAction } from '../types/actions'

import { actionFactory } from './factory'

export const FeatureFlagsSchema = z
  .record(
    z.string().transform((val) => camel(val)),
    z.boolean().or(z.string()).catch(false)
  )
  .optional()
  .default({})

export const featureFlagsChanged = actionFactory<FeatureFlagsChangedAction>(
  (state, { featureFlags }) => {
    state.featureFlags = FeatureFlagsSchema.parse(featureFlags)
  },
  'featureFlagsChanged'
)
